
import { charlotteMediaArray } from './charlotteMedia'
import { carrieReviewerProfile, mirandaReviewerProfile, samanthaReviewerProfile } from './charlotteReviewers'
import { samanthaBio, carrieBio, charlotteBio, mirandaBio } from './charlotteBios'
import { charlotteDatingProfileHinge, charlotteDatingProfileBumble, charlotteDatingProfileTinder } from './charlotteDatingProfiles'

export const charlotteUser = {
  _id: 'charlotteUserId',
  email: 'charlotte@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...carrieReviewerProfile },
    { ...mirandaReviewerProfile },
    { ...samanthaReviewerProfile }
  ],
  media: [ ...charlotteMediaArray ],
  bio: { ...charlotteBio },
  datingProfiles: [
    { ...charlotteDatingProfileHinge },
    { ...charlotteDatingProfileBumble },
    { ...charlotteDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const carrieUser = {
  _id: 'carrieUserId',
  email: 'carrie@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...carrieBio },
  datingProfiles: [],
  reviewerProfile: { ...carrieReviewerProfile },
}

export const mirandaUser = {
  _id: 'mirandaUserId',
  email: 'miranda@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...mirandaBio },
  datingProfiles: [],
  reviewerProfile: { ...mirandaReviewerProfile },
}

export const samanthaUser = {
  _id: 'samanthaUserId',
  email: 'samantha@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...samanthaBio },
  datingProfiles: [],
  reviewerProfile: { ...samanthaReviewerProfile },
}
